module.exports = __webpack_public_path__ + "img/3Dian5_4.bbdcd862.png";